import React, { useState } from "react";
import "../styles/InstructorRegistrationPage.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const InstructorRegistrationPage = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        title: "",
        email: "",
        phone: "",
        experience: "",
        courseTitle: "",
        courseDescription: "",
        courseCategory: "",
        qualifications: "",
        bio: "",
        avesisUrl: "",
        password: "",
        confirmPassword: "",
        cv: null,
        profileImage: null
    });

    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];
        setFormData(prev => ({ ...prev, [name]: file }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        // Form validation
        if (!formData.firstName || !formData.lastName || !formData.email || !formData.phone || !formData.title) {
            toast.error("Lütfen zorunlu alanları doldurun.", {
                position: "top-right",
                autoClose: 3000,
            });
            setIsLoading(false);
            return;
        }

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            toast.error("Geçerli bir e-posta adresi girin.", {
                position: "top-right",
                autoClose: 3000,
            });
            setIsLoading(false);
            return;
        }

        // Password validation
        if (formData.password && formData.password.length < 6) {
            toast.error("Şifre en az 6 karakter olmalıdır.", {
                position: "top-right",
                autoClose: 3000,
            });
            setIsLoading(false);
            return;
        }

        if (formData.password !== formData.confirmPassword) {
            toast.error("Şifreler eşleşmiyor.", {
                position: "top-right",
                autoClose: 3000,
            });
            setIsLoading(false);
            return;
        }

        try {
            const formDataToSend = new FormData();
            Object.keys(formData).forEach(key => {
                if (formData[key] !== null) {
                    formDataToSend.append(key, formData[key]);
                }
            });

            const response = await fetch(`${process.env.REACT_APP_API_URL}/instructor/register`, {
                method: "POST",
                body: formDataToSend
            });

            if (response.ok) {
                toast.success("Başvurunuz başarıyla gönderildi! En kısa sürede size dönüş yapacağız.", {
                    position: "top-right",
                    autoClose: 5000,
                });
                setFormData({
                    firstName: "",
                    lastName: "",
                    title: "",
                    email: "",
                    phone: "",
                    experience: "",
                    courseTitle: "",
                    courseDescription: "",
                    courseCategory: "",
                    qualifications: "",
                    bio: "",
                    avesisUrl: "",
                    password: "",
                    confirmPassword: "",
                    cv: null,
                    profileImage: null
                });
                // Reset file inputs
                document.getElementById('cv-upload').value = '';
                document.getElementById('profile-image-upload').value = '';
            } else {
                toast.error("Başvuru gönderilirken bir hata oluştu. Lütfen tekrar deneyin.", {
                    position: "top-right",
                    autoClose: 5000,
                });
            }
        } catch (error) {
            console.error("Error submitting instructor application:", error);
            toast.error("Bir hata oluştu. Lütfen daha sonra tekrar deneyin.", {
                position: "top-right",
                autoClose: 5000,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="instructor-registration-container">
                <div className="instructor-registration-header">
                    <div className="header-content">
                        <h1>MeduVR'da Ders Vermek İster misiniz?</h1>
                        <p>Deneyiminizi paylaşın ve yeni nesil öğrencilere rehberlik edin. Sanal gerçeklik teknolojisi ile eğitimin geleceğine katkıda bulunun.</p>
                    </div>
                </div>

                <div className="instructor-registration-form-section">
                    <div className="container">
                        <div className="form-wrapper">
                            <div className="form-header">
                                <h2>Eğitmen Başvuru Formu</h2>
                                <p>Bilgilerinizi doldurun ve MeduVR ailesine katılın</p>
                            </div>

                            <form onSubmit={handleSubmit} className="instructor-form">
                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="firstName">
                                            Ad <span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="firstName"
                                            name="firstName"
                                            value={formData.firstName}
                                            onChange={handleChange}
                                            required
                                            placeholder="Adınızı girin"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="lastName">
                                            Soyad <span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="lastName"
                                            name="lastName"
                                            value={formData.lastName}
                                            onChange={handleChange}
                                            required
                                            placeholder="Soyadınızı girin"
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="email">
                                            E-posta <span className="required">*</span>
                                        </label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            placeholder="ornek@email.com"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="phone">
                                            Telefon <span className="required">*</span>
                                        </label>
                                        <input
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            required
                                            placeholder="+90 5xx xxx xx xx"
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="title">
                                        Unvan <span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="title"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                        required
                                        placeholder="Unvanınızı girin"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="courseCategory">
                                        Ders Kategorisi
                                    </label>
                                    <select
                                        id="courseCategory"
                                        name="courseCategory"
                                        value={formData.courseCategory}
                                        onChange={handleChange}
                                    >
                                        <option value="">Kategori seçin</option>
                                        <option value="tip">Tıp</option>
                                        <option value="hemsirelik">Hemşirelik</option>
                                        <option value="fizyoterapi">Fizyoterapi</option>
                                        <option value="saglik-yonetimi">Sağlık Yönetimi</option>
                                        <option value="eczacilik">Eczacılık</option>
                                        <option value="diger">Diğer</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="courseTitle">
                                        Vermek İstediğiniz Ders Başlığı
                                    </label>
                                    <input
                                        type="text"
                                        id="courseTitle"
                                        name="courseTitle"
                                        value={formData.courseTitle}
                                        onChange={handleChange}
                                        placeholder="Ders başlığını girin"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="courseDescription">
                                        Ders Hakkında Detaylar
                                    </label>
                                    <textarea
                                        id="courseDescription"
                                        name="courseDescription"
                                        value={formData.courseDescription}
                                        onChange={handleChange}
                                        rows="4"
                                        placeholder="Dersinizin içeriği, hedef kitlesi ve öğrenme hedefleri hakkında detaylı bilgi verin..."
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="experience">
                                        Deneyim ve Uzmanlık Alanları
                                    </label>
                                    <textarea
                                        id="experience"
                                        name="experience"
                                        value={formData.experience}
                                        onChange={handleChange}
                                        rows="3"
                                        placeholder="Profesyonel deneyiminiz, uzmanlık alanlarınız ve neden MeduVR'da ders vermek istediğiniz hakkında bilgi verin..."
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="qualifications">
                                        Eğitim ve Sertifikalar
                                    </label>
                                    <textarea
                                        id="qualifications"
                                        name="qualifications"
                                        value={formData.qualifications}
                                        onChange={handleChange}
                                        rows="3"
                                        placeholder="Mezun olduğunuz okul, sahip olduğunuz sertifikalar ve akademik başarılarınız..."
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="bio">
                                        Kısa Biyografi
                                    </label>
                                    <textarea
                                        id="bio"
                                        name="bio"
                                        value={formData.bio}
                                        onChange={handleChange}
                                        rows="3"
                                        placeholder="Kendiniz hakkında kısa bir bilgi verin..."
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="avesisUrl">
                                        Avesis URL
                                    </label>
                                    <input
                                        type="text"
                                        id="avesisUrl"
                                        name="avesisUrl"
                                        value={formData.avesisUrl}
                                        onChange={handleChange}
                                        placeholder="Avesis profil URL'nizi girin"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="password">
                                        Şifre
                                    </label>
                                    <input
                                        type="password"
                                        id="password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        placeholder="Şifrenizi belirleyin"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="confirmPassword">
                                        Şifreyi Onayla
                                    </label>
                                    <input
                                        type="password"
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        value={formData.confirmPassword}
                                        onChange={handleChange}
                                        placeholder="Şifrenizi onaylayın"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="cv-upload">
                                        Özgeçmiş (PDF formatında)
                                    </label>
                                    <input
                                        type="file"
                                        id="cv-upload"
                                        name="cv"
                                        accept=".pdf"
                                        onChange={handleFileChange}
                                        className="file-input"
                                    />
                                    <div className="file-input-info">
                                        <i className="fas fa-cloud-upload-alt"></i>
                                        <span>PDF dosyanızı seçin veya sürükleyip bırakın</span>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="profileImage-upload">
                                        Profil Resmi (Opsiyonel)
                                    </label>
                                    <input
                                        type="file"
                                        id="profileImage-upload"
                                        name="profileImage"
                                        accept="image/*"
                                        onChange={handleFileChange}
                                        className="file-input"
                                    />
                                    <div className="file-input-info">
                                        <i className="fas fa-cloud-upload-alt"></i>
                                        <span>Profil resminizi seçin veya sürükleyip bırakın</span>
                                    </div>
                                </div>

                                <button
                                    type="submit"
                                    className="submit-btn"
                                    disabled={isLoading}
                                >
                                    {isLoading ? (
                                        <>
                                            <i className="fas fa-spinner fa-spin"></i>
                                            Gönderiliyor...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fas fa-paper-plane"></i>
                                            Başvuruyu Gönder
                                        </>
                                    )}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default InstructorRegistrationPage;
